/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Quota_Warning_LowInputs */

const en_quota_warning_low = /** @type {(inputs: Quota_Warning_LowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quota nearly reached`)
};

const fr_quota_warning_low = /** @type {(inputs: Quota_Warning_LowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quota presque atteint`)
};

const ms_sg2_quota_warning_low = /** @type {(inputs: Quota_Warning_LowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kuota hampir habis`)
};

/**
* | output |
* | --- |
* | "Quota nearly reached" |
*
* @param {Quota_Warning_LowInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const quota_warning_low = /** @type {((inputs?: Quota_Warning_LowInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Quota_Warning_LowInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_quota_warning_low(inputs)
	if (locale === "fr") return fr_quota_warning_low(inputs)
	return ms_sg2_quota_warning_low(inputs)
});